module.exports = __webpack_public_path__ + "img/img_interior02.8eb16147.jpg";